import { createFetchedData, LoadingState } from '@vista-digital/utilities';
import { defaultMemberJourneysState } from '../types/member-journeys-state';
export const defaultTemporaryLoyaltyDomainState = {
    isMemberSignedIn: false,
    member: createFetchedData(LoadingState.NotLoaded),
    memberJourneys: defaultMemberJourneysState,
    memberPaymentCards: createFetchedData(LoadingState.NotLoaded),
    memberTicketRedemptionCards: createFetchedData(LoadingState.NotLoaded),
    memberTransactions: createFetchedData(LoadingState.NotLoaded),
    memberWatchedFilmsByYear: {}
};
//# sourceMappingURL=state.js.map